import produce from 'immer';
const cleanMetadata = (metadataFields, orgMetadataFields) => {
    let modifiedMetadata = produce(metadataFields, draft => {
        for (const index in draft) {
            const metadata = draft[index];
            const orgMetaDataIndex = orgMetadataFields.findIndex(metadataField => metadataField.name === metadata.name);
            if (orgMetaDataIndex !== -1 && orgMetadataFields[orgMetaDataIndex].type === 'date') {
                const dateValue = metadata.value;
                if (typeof dateValue === 'string' && dateValue.length === 7) {
                    metadata.value = `${dateValue}-01`;
                }
            }
        }
    });
    modifiedMetadata = modifiedMetadata.filter(metadataField => {
        if (metadataField.value instanceof Array) {
            return metadataField.value.length > 0;
        }
        return metadataField.value !== null &&
            metadataField.value !== undefined &&
            metadataField.value !== '';
    });
    const oddMetadata = {};
    for (const metadataField of modifiedMetadata) {
        oddMetadata[metadataField.name] = metadataField.value;
    }
    return oddMetadata;
};
export default cleanMetadata;
